import React from 'react';
import styled from 'styled-components/macro';

import { breakPoint, palette } from '@mirinae/react-ui';

import SignupBottomMenu from '@mirinae/explorer/components/userauth/SignupBottomMenu';
import BackgroundCircles from '@mirinae/explorer/components/assets/bg-signup-circles.svg';


const OuterCircleBackground = styled.div`
    position: fixed;
    width: 2864px;
    height: 2864px;
    top: calc(50% - 2864px/2);
    ${props => ((props.theme === 'login') ? 'left : calc(-2864px/2)' : 'right : calc(-2864px/2)')};
    background: ${palette.primary.white};
    border-radius: 50%;
    z-index: -100;
    @media only screen and (max-width: ${breakPoint.sm}) {
        display: none;
    }
`;

const InnerCircleImage = styled.div`
    position: fixed;
    width: 605px;
    top: calc(50vh - 68px - 605px/2);
    /* left: -302.5px; */
    ${props => ((props.theme === 'login') ? 'left : calc(-605px/2)' : 'right : calc(-605px/2)')};
    background: url(${BackgroundCircles}) no-repeat center;
    z-index: -1;
    aspect-ratio: 1 / 1;
    @media only screen and (max-width: ${breakPoint.sm}) {
        display: none;
    }
`;

const SignupBackground = ({ theme }) => (
    <>
        <OuterCircleBackground theme={theme}> 
            <InnerCircleImage theme={theme} />
        </OuterCircleBackground>
        <SignupBottomMenu />
    </>
);

export default SignupBackground;